import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LabelI18nService } from 'src/app/core/_services/label-i18n.service';
import { RegisterRequest } from 'src/app/core/_models/register-request';

@Component({
  selector: 'app-dialog-register-request',
  templateUrl: './dialog-register-request.component.html',
  styleUrls: ['./dialog-register-request.component.scss']
})
export class DialogRegisterRequestComponent {
  confirmingRefusal = false;

  constructor(
    public dialogRef: MatDialogRef<DialogRegisterRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegisterRequest,
    private translate: TranslateService,
    private labelI18n: LabelI18nService
  ) {}

  profileLabel(code: string): string {
    if (!code) {
      return '';
    }
    const key = `validation_profile_${code}`;
    const label = this.translate.instant(key);
    return label === key ? code : label;
  }

  adhesionLabel(adhesion: string): string {
    if (!adhesion) {
      return '—';
    }
    return this.translate.instant(adhesion === 'adherente' ? 'inscription_fntp_member' : 'inscription_fntp_non_member');
  }

  countryLabel(code: string | null): string {
    return code ? this.labelI18n.countryName(code) : '—';
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onAccept(): void {
    this.dialogRef.close('accept');
  }

  askRefusal(): void {
    this.confirmingRefusal = true;
  }

  cancelRefusal(): void {
    this.confirmingRefusal = false;
  }

  onRefuse(): void {
    this.dialogRef.close('refuse');
  }
}
